import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { fetchAuthSession } from 'aws-amplify/auth';

export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  try {
    const session = await fetchAuthSession();
    const tokens = session.tokens;
    if (!tokens) return router.createUrlTree(['/login']);
    return true;
  } catch (error) {
    return router.createUrlTree(['/login']);
  }
};
